import { memo, useCallback, useState } from 'react';

import Placeholder from '../../../../elements/Placeholder';
import { getFontScale } from '../../../../utils/layoutHelpers';
import styles, { S } from './styles';

interface Props {
  width: number;
  imageSize: number;
  isLarge: boolean;
}

function LoadingItem(props: Props) {
  const { width, imageSize, isLarge } = props;
  const fontScale = getFontScale();

  const imageCount = isLarge ? 5 : 2;

  const [responsiveSize, setResponsiveSize] = useState(imageSize);
  const handleLayout = useCallback(
    e => {
      const size = isLarge ? e.nativeEvent.layout.height : imageSize;

      setResponsiveSize(size);
    },
    [isLarge, imageSize, setResponsiveSize]
  );

  return (
    <S.Container>
      <Placeholder height={20 * fontScale} width={width * 0.65} />
      <Placeholder
        boxStyle={styles.secondaryBox}
        height={14 * fontScale}
        width={width * 0.35}
      />
      <S.ImagesContainer onLayout={handleLayout}>
        {new Array(imageCount).fill('').map((_, index) => (
          <Placeholder
            key={`${responsiveSize}-${index}`}
            height={responsiveSize}
            width={responsiveSize}
            boxStyle={styles.imgBoxStyle}
          />
        ))}
      </S.ImagesContainer>
    </S.Container>
  );
}

export default memo(LoadingItem);
